import {
  EM_FILA,
  ERRO,
  PROCESSADO_COM_SUCESSO,
  PROCESSAMENTO
} from "./estados";

const ESTADOS_FILA = ["RECEBIDO"];
const ESTADOS_PROCESSAMENTO = [
  "VALIDANDO",
  "ASSINANDO",
  "ENVIANDO",
  "AGUARDANDO_PROCESSAMENTO"
];
const ESTADOS_SUCESSO = ["PROCESSADO_SUCESSO"];
const ESTADOS_ERRO = [
  "PROCESSADO_ERRO",
  "ERRO_CERTIFICADO",
  "ERRO_COMUNICACAO",
  "ERRO_INTERNO"
];

const DESCRICOES = {
  RECEBIDO: "Recebido",
  VALIDANDO: "Validando",
  ASSINANDO: "Assinando",
  ENVIANDO: "Enviando",
  AGUARDANDO_PROCESSAMENTO: "Aguardando processamento",
  PROCESSADO_SUCESSO: "Processado com sucesso",
  PROCESSADO_ERRO: "Processado com erro",
  ERRO_CERTIFICADO: "Erro de certificado",
  ERRO_COMUNICACAO: "Erro de comunicação",
  ERRO_INTERNO: "Erro interno"
};

export function estadoVisualEnvio(estado) {
  if (ESTADOS_FILA.includes(estado)) {
    return { id: EM_FILA, descricao: descricaoEstado(estado) };
  }
  if (ESTADOS_PROCESSAMENTO.includes(estado)) {
    return { id: PROCESSAMENTO, descricao: descricaoEstado(estado) };
  }
  if (ESTADOS_SUCESSO.includes(estado)) {
    return { id: PROCESSADO_COM_SUCESSO, descricao: descricaoEstado(estado) };
  }
  if (ESTADOS_ERRO.includes(estado)) {
    return { id: ERRO, descricao: descricaoEstado(estado) };
  }
  return { id: EM_FILA, descricao: descricaoEstado(estado) };
}

export function descricaoEstado(estado) {
  return DESCRICOES[estado] || estado || "Recebido";
}

export function tituloEnvio(envio) {
  return `${envio.tipoEvento || "Evento"} - ${envio.externalId || envio.id}`;
}

export function resumoEnvio(envio) {
  return [
    ["Empregador", envio.empregador],
    ["Ambiente", envio.ambiente],
    ["Código", envio.codigo],
    ["Recibo", envio.recibo],
    ["Protocolo", envio.protocolo]
  ].filter(([, value]) => value);
}
